import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Button, Typography } from "@mui/material";
import DashboardLayout from "components/layouts/DashboardLayout";
import ConsentDocumentsSection from "components/Patient/ConsentDocumentsSection";
import ContactInformationSection from "components/Patient/ContactInformationSection";
import EmergencyContactSection from "components/Patient/EmergencyContactSection";
import InsuranceBillingSection from "components/Patient/InsuranceBillingSection";
import MedicationHistorySection from "components/Patient/MedicationHistorySection";
import MedicationInformationSection from "components/Patient/MedicationInformationSection";
import PersonalInformationSection from "components/Patient/PersonalInformationSection";
import { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { CreatePatientForm } from "types";
import { patientSchema } from "validations/patientSchemas";

function AddPatientPage() {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const createPatientForm = useForm({
    resolver: yupResolver(patientSchema),
    defaultValues: {
      firstName: "",
      middleName: "",
      lastName: "",
      dateOfBirth: undefined,
      gender: undefined,
      maritalStatus: undefined,
      address: "",
      email: "",
      phoneNumber: "",
      alternativePhone: "",
      preferredContactMethod: undefined,
      profileImage: null,

      // Emergency Contact
      emergencyContactName: "",
      emergencyContactRelationship: undefined,
      emergencyContactPhone: "",
      emergencyContactEmail: "",

      // Medication Information
      bloodType: undefined,
      height: undefined,
      weight: undefined,
      allergies: "",
      currentMedicine: "",
      chronicConditions: "",

      // Medication History
      pastSurgeries: "",
      pastHospitalizations: "",
      familyMedicalHistory: [],

      // Insurance & Billing Information
      insuranceNumber: "",
      insuranceProvider: "",

      // Consent & Documents
      hipaaConsentForm: undefined,
      treatmentConsent: undefined,
      financialAgreement: undefined,
    },
    mode: "onChange",
  });

  const onSubmit = async (data: CreatePatientForm) => {
    try {
      setIsSubmitting(true);
      // Here you would handle the form submission, e.g., API call to create patient
      console.log("Form data:", data);

      // Simulate API call
      await new Promise((resolve) => setTimeout(resolve, 1000));

      // Reset form after successful submission
      createPatientForm.reset();

      // Show success message or redirect
      alert("Patient added successfully!");
    } catch (error) {
      console.error("Error adding patient:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <DashboardLayout title="Patient">
      <Typography variant="h4" component="h1" className="mb-6 font-bold">
        Add Patient
      </Typography>
      <FormProvider {...createPatientForm}>
        <form onSubmit={createPatientForm.handleSubmit(onSubmit)}>
          <PersonalInformationSection />
          <ContactInformationSection />
          <EmergencyContactSection />
          <MedicationInformationSection />
          <MedicationHistorySection />
          <InsuranceBillingSection />
          <ConsentDocumentsSection />
          <Box className="flex justify-end gap-4 mt-8">
            <Button
              type="submit"
              variant="contained"
              className="px-6 py-2 rounded-full"
              disabled={isSubmitting || !createPatientForm.formState.isValid}
            >
              {isSubmitting ? "Saving..." : "Add Patient"}
            </Button>
          </Box>
        </form>
      </FormProvider>
    </DashboardLayout>
  );
}

export default AddPatientPage;
